/*
	FILE GOES IN: assets/moode.js
*/


// Supplement Popup Functions
function openSupplementPopup() {
    const popup = document.getElementById('supplementPopup');
    if (popup) {
        popup.classList.add('active');
        document.body.style.overflow = 'hidden';
    }
}

function closeSupplementPopup(event) {
    if (event && event.target !== event.currentTarget) return;
    const popup = document.getElementById('supplementPopup');
    if (popup) {
        popup.classList.remove('active');
        document.body.style.overflow = 'auto';
    }
}

// Close popup with Escape key
document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape') {
        closeSupplementPopup();
    }
});

// Ensure functions are available globally
window.openSupplementPopup = openSupplementPopup;
window.closeSupplementPopup = closeSupplementPopup;


// Open Shopify Chat from a link in the footer 'Help' nav.
    (function () {
    'use strict';

    // Guard: don't bind twice if this file ever loads more than once
    if (window.__helpChatTriggerInitialized) return;
    window.__helpChatTriggerInitialized = true;

    function openShopifyChatFromFooterLink(event) {
        var helpLink = event.target.closest('a[href="#footer-help-link"]');
        if (!helpLink) return;

        event.preventDefault();

        var chatHost = document.querySelector('shopify-chat');
        var activatorBtn = chatHost && chatHost.shadowRoot
        ? chatHost.shadowRoot.querySelector('[part="activator"]')
        : null;

        if (activatorBtn) {
        activatorBtn.click();
        } else {
        console.warn('[HelpChatTrigger] Shopify chat activator button not found.');
        }
    }

    document.addEventListener('click', openShopifyChatFromFooterLink);
    })();


// Sticky add to cart bar: pack size chips.
// The chips in snippets/moode-sticky-bar.liquid are plain buttons. Clicking one
// finds the matching input in the real variant picker and clicks it, so the
// theme handles the variant change and there is no duplicate radio group.
//
// Two things worth knowing if this ever needs touching again.
//
// The variant picker radios live outside the <form> element and are linked to
// it by a form attribute. form.querySelector only searches inside the form, so
// it never finds them. form.elements does, because it includes every
// form associated control wherever it sits in the page.
//
// The value attribute on those radios is either the option value id or its
// name depending on the theme version, so both are checked.
    (function () {
    'use strict';

    if (window.__moodeStickyBarInitialized) return;
    window.__moodeStickyBarInitialized = true;

    function findOptionInput(form, valueId, valueName) {
        var candidates = Array.prototype.filter.call(form.elements, function (element) {
        return element.matches && element.matches('input[data-option-position]');
        });

        for (var i = 0; i < candidates.length; i++) {
        var value = candidates[i].value;
        if (value === valueId || value === valueName) {
            return candidates[i];
        }
        }

        return null;
    }

    function onChipClicked(event) {
        var chip = event.target.closest('.moode-sticky-bar__chip');
        if (!chip || chip.disabled || chip.classList.contains('is-selected')) return;

        var inner = chip.closest('[data-form-id]');
        if (!inner) return;

        var form = document.forms[inner.getAttribute('data-form-id')];
        if (!form) {
        console.warn('[moodeStickyBar] Product form not found.');
        return;
        }

        var valueId = chip.getAttribute('data-option-value-id');
        var valueName = chip.getAttribute('data-option-value-name');
        var input = findOptionInput(form, valueId, valueName);

        if (input) {
        input.click();
        } else {
        console.warn('[moodeStickyBar] No matching variant input for "' + valueName + '" (id ' + valueId + ').');
        }
    }

    document.addEventListener('click', onChipClicked);
    })();


// Cart drawer: switch to subscribe and save.
// The prompt in snippets/moode-subscribe-prompt.liquid carries the line item
// key and the selling plan id. This swaps that line item onto the plan and
// lets the theme re-render the drawer from the server.
    (function () {
    'use strict';

    if (window.__moodeSubscribeSwitchInitialized) return;
    window.__moodeSubscribeSwitchInitialized = true;

    async function switchToSubscription(button) {
        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

        button.setAttribute('aria-busy', 'true');
        document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));

        var sectionsToBundle = [];
        document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {
        bubbles: true,
        detail: { sections: sectionsToBundle }
        }));

        try {
        var response = await fetch(root + 'cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
            id: button.getAttribute('data-line-key'),
            quantity: parseInt(button.getAttribute('data-quantity'), 10) || 1,
            selling_plan: parseInt(button.getAttribute('data-selling-plan'), 10),
            sections: sectionsToBundle.join(',')
            })
        });

        document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));

        if (!response.ok) {
            button.removeAttribute('aria-busy');
            console.warn('[moodeSubscribeSwitch] Could not switch the line item to a subscription.');
            return;
        }

        var cartContent = await response.json();

        if (window.themeVariables && window.themeVariables.settings.pageType === 'cart') {
            window.location.reload();
            return;
        }

        document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
            bubbles: true,
            detail: {
            baseEvent: 'moode:subscribe-switch',
            cart: cartContent
            }
        }));
        } catch (error) {
        document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
        button.removeAttribute('aria-busy');
        console.warn('[moodeSubscribeSwitch]', error);
        }
    }

    document.addEventListener('click', function (event) {
        var button = event.target.closest('.moode-subscribe-prompt__button');
        if (!button || button.getAttribute('aria-busy') === 'true') return;
        switchToSubscription(button);
    });
    })();


// Stockists page filtering.
// Every stockist stays in the HTML on load, so the list is readable by search
// engines whichever filter is active. Filtering only toggles visibility.
    (function () {
    'use strict';

    if (window.__moodeStockistsInitialized) return;
    window.__moodeStockistsInitialized = true;

    function setup(section) {
        var filters = Array.prototype.slice.call(section.querySelectorAll('.moode-filter'));
        var cards = Array.prototype.slice.call(section.querySelectorAll('.moode-stockist'));
        var count = section.querySelector('[data-stockist-count]');
        var empty = section.querySelector('[data-stockist-empty]');

        if (!cards.length) return;

        function apply(value) {
        var shown = 0;

        cards.forEach(function (card) {
            var regions = (card.getAttribute('data-regions') || '').split(/[\s,]+/);
            var show = value === 'all' || regions.indexOf(value) !== -1;
            card.classList.toggle('is-hidden', !show);
            if (show) shown++;
        });

        filters.forEach(function (button) {
            var isActive = button.getAttribute('data-filter') === value;
            button.classList.toggle('is-active', isActive);
            button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });

        if (count) {
            count.textContent = shown + (shown === 1 ? ' stockist' : ' stockists');
        }

        if (empty) {
            empty.hidden = shown !== 0;
        }
        }

        filters.forEach(function (button) {
        button.addEventListener('click', function () {
            apply(button.getAttribute('data-filter'));
        });
        });

        apply('all');
    }

    function init() {
        document.querySelectorAll('.shopify-section--moode-stockists').forEach(setup);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }

    // The theme editor re-renders sections, so rebind when it does.
    document.addEventListener('shopify:section:load', function (event) {
        if (event.target.classList.contains('shopify-section--moode-stockists')) {
        window.__moodeStockistsInitialized = false;
        setup(event.target);
        window.__moodeStockistsInitialized = true;
        }
    });
    })();


// FAQ page search and category filtering.
// Everything stays in the HTML on load, so the full set is readable by search
// engines and AI assistants whatever is typed. This only toggles visibility.
    (function () {
    'use strict';

    if (window.__moodeFaqsInitialized) return;
    window.__moodeFaqsInitialized = true;

    function setup(root) {
        var search = root.querySelector('[data-faq-search]');
        var clear = root.querySelector('[data-faq-clear]');
        var filters = Array.prototype.slice.call(root.querySelectorAll('[data-faq-filter]'));
        var groups = Array.prototype.slice.call(root.querySelectorAll('[data-faq-group]'));
        var items = Array.prototype.slice.call(root.querySelectorAll('[data-faq-item]'));
        var empty = root.querySelector('[data-faq-empty]');

        if (!items.length) return;

        var activeFilter = 'all';

        function apply() {
        var term = search ? search.value.trim().toLowerCase() : '';
        var shown = 0;

        groups.forEach(function (group) {
            var groupId = group.getAttribute('data-faq-group');
            var inFilter = activeFilter === 'all' || activeFilter === groupId;
            var groupShown = 0;

            Array.prototype.forEach.call(group.querySelectorAll('[data-faq-item]'), function (item) {
            var matches = inFilter && (term === '' || item.textContent.toLowerCase().indexOf(term) !== -1);
            item.classList.toggle('is-hidden', !matches);
            if (matches) groupShown++;
            });

            group.classList.toggle('is-hidden', groupShown === 0);
            shown += groupShown;
        });

        if (empty) empty.hidden = shown !== 0;
        if (clear) clear.hidden = term === '';
        }

        filters.forEach(function (button) {
        button.addEventListener('click', function () {
            activeFilter = button.getAttribute('data-faq-filter');
            filters.forEach(function (other) {
            var isActive = other === button;
            other.classList.toggle('is-active', isActive);
            other.setAttribute('aria-pressed', isActive ? 'true' : 'false');
            });
            apply();
        });
        });

        if (search) {
        search.addEventListener('input', apply);
        }

        if (clear) {
        clear.addEventListener('click', function () {
            if (search) {
            search.value = '';
            search.focus();
            }
            apply();
        });
        }

        apply();
    }

    function init() {
        document.querySelectorAll('[data-moode-faqs]').forEach(setup);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }

    document.addEventListener('shopify:section:load', function (event) {
        var root = event.target.querySelector('[data-moode-faqs]');
        if (root) setup(root);
    });
    })();


// Homepage 2.0 behaviour.
// Scroll reveals, the blur to sharp image circles, the nutrient explanation
// swap.
    (function () {
    'use strict';

    if (window.__moodeHomeInitialized) return;
    window.__moodeHomeInitialized = true;

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var canHover = window.matchMedia('(hover: hover)').matches;

    /* Reveals and the blurred circles. Both use one observer. */
    function initReveals(root) {
        var targets = [].slice.call(root.querySelectorAll('[data-moode-reveal], [data-moode-blur]'));
        if (!targets.length) return;

        if (reduce || !('IntersectionObserver' in window)) {
        targets.forEach(function (el) {
            el.classList.add('is-in');
            el.classList.add('is-sharp');
        });
        return;
        }

        var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-in');
            if (entry.target.hasAttribute('data-moode-blur')) {
            entry.target.classList.add('is-sharp');
            }
            observer.unobserve(entry.target);
        });
        }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

        targets.forEach(function (el) { observer.observe(el); });
    }

    /* Nutrient explanations.
       Desktop: the panel replaces the centre image on hover or tap.
       Mobile: the same panel moves to sit under its own nutrient and opens
       like an accordion, because swapping an image that has scrolled off
       screen is invisible. The elements are moved, never duplicated, so the
       text exists once in the page for search engines and AI assistants. */
    function initNutrients(root) {
        root.querySelectorAll('[data-moode-nutrients]').forEach(function (section) {
        var buttons = [].slice.call(section.querySelectorAll('[data-nutrient]'));
        var panels = [].slice.call(section.querySelectorAll('[data-nutrient-why]'));
        var mid = section.querySelector('.moode-nutrients__mid');
        if (!buttons.length || !panels.length || !mid) return;

        var narrow = window.matchMedia('(max-width: 899px)');

        function clear() {
            panels.forEach(function (p) { p.classList.remove('is-on'); });
            buttons.forEach(function (b) {
            b.classList.remove('is-active');
            b.setAttribute('aria-expanded', 'false');
            });
            mid.classList.remove('is-open');
        }

        function show(id) {
            panels.forEach(function (p) { p.classList.toggle('is-on', p.getAttribute('data-nutrient-why') === id); });
            buttons.forEach(function (b) {
            var on = b.getAttribute('data-nutrient') === id;
            b.classList.toggle('is-active', on);
            b.setAttribute('aria-expanded', on ? 'true' : 'false');
            });
            mid.classList.toggle('is-open', !narrow.matches);
        }

        function place() {
            clear();
            panels.forEach(function (panel) {
            var id = panel.getAttribute('data-nutrient-why');
            if (narrow.matches) {
                var item = section.querySelector('[data-nutrient-item="' + id + '"]');
                if (item && panel.parentElement !== item) item.appendChild(panel);
            } else if (panel.parentElement !== mid) {
                mid.appendChild(panel);
            }
            });
        }

        buttons.forEach(function (button) {
            var id = button.getAttribute('data-nutrient');

            button.addEventListener('mouseenter', function () {
            if (canHover && !narrow.matches) show(id);
            });

            button.addEventListener('focus', function () {
            if (canHover && !narrow.matches) show(id);
            });

            button.addEventListener('click', function () {
            if (button.classList.contains('is-active')) { clear(); } else { show(id); }
            });
        });

        var orbit = section.querySelector('.moode-nutrients__orbit');
        if (orbit) {
            orbit.addEventListener('mouseleave', function () {
            if (canHover && !narrow.matches) clear();
            });
        }

        place();

        /* Open the first nutrient on desktop so the pattern is obvious without
           a line of copy telling people to tap. Mobile stays closed, since an
           open accordion at the top just pushes the rest down. */
        function primeFirst() {
            if (narrow.matches) { clear(); return; }
            var first = buttons[0];
            if (first) show(first.getAttribute('data-nutrient'));
        }

        primeFirst();

        function onBreakpointChange() {
            place();
            primeFirst();
        }

        if (narrow.addEventListener) {
            narrow.addEventListener('change', onBreakpointChange);
        } else if (narrow.addListener) {
            narrow.addListener(onBreakpointChange);
        }
        });
    }

    function init(root) {
        initReveals(root);
        initNutrients(root);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () { init(document); });
    } else {
        init(document);
    }

    // The theme editor re-renders sections, so rebind when it does.
    document.addEventListener('shopify:section:load', function (event) {
        init(event.target);
    });
    })();


// Sale template: strip any selling plan from the product form.
// A link carrying ?selling_plan= could otherwise attach a subscription on a
// page where subscriptions are deliberately switched off. This only runs on
// the sale template, so it cannot affect normal trading.
    (function () {
    'use strict';

    if (window.__moodeSaleGuardInitialised) return;
    window.__moodeSaleGuardInitialised = true;

    if (!document.body.classList.contains('template-product-moode-sale-product')) return;

    function strip() {
        document.querySelectorAll('input[name="selling_plan"], select[name="selling_plan"]').forEach(function (field) {
        field.remove();
        });
    }

    strip();
    document.addEventListener('product:rerender', strip);
    })();
